import { SearchOperations } from 'constants/searchOperations';
import {
  LEASE_TYPE_ID_MAP,
  LeaseRecordType,
  LeaseTypeEnum,
} from 'constants/leases';
import { SearchOptionsType } from 'interfaces/ISearchOptionsType';
import { IProperty } from 'interfaces/IProperty';
import { IdName } from 'interfaces/IdName';
import { formatEnumLabel, upperFirstLetter } from 'utils/formatters/string';
import { isUKCountry, isDataCenterBuilding } from 'utils/properties';
import { translateText } from 'utils/i18n';

export const LEASE_TYPE_OPTIONS: SearchOptionsType[] = [
  {
    id: 1,
    name: upperFirstLetter(LeaseTypeEnum.DIRECT),
    field: 'type',
    filter: {
      operator: SearchOperations.ilike,
      value: LeaseTypeEnum.DIRECT,
    },
  },
  {
    id: 4,
    name: upperFirstLetter(LeaseTypeEnum.SUBLEASE),
    field: 'type',
    filter: {
      operator: SearchOperations.ilike,
      value: LeaseTypeEnum.SUBLEASE,
    },
  },
  {
    id: 2,
    name: upperFirstLetter(LeaseTypeEnum.LICENSE),
    field: 'type',
    filter: {
      operator: SearchOperations.ilike,
      value: LeaseTypeEnum.LICENSE,
    },
  },
  {
    id: 3,
    name: upperFirstLetter(LeaseTypeEnum.ASSIGNMENT),
    field: 'type',
    filter: {
      operator: SearchOperations.ilike,
      value: LeaseTypeEnum.ASSIGNMENT,
    },
  },
];

export const LEASE__DATA_CENTER_OPTIONS = [
  {
    id: 6,
    name: upperFirstLetter(LeaseTypeEnum.SHELL),
    field: 'type',
    filter: {
      operator: SearchOperations.ilike,
      value: LeaseTypeEnum.SHELL,
    },
  },
  {
    id: 7,
    name: formatEnumLabel(LeaseTypeEnum.TURN_KEY),
    field: 'type',
    filter: {
      operator: SearchOperations.ilike,
      value: LeaseTypeEnum.TURN_KEY,
    },
  },
];

export const getLeaseTypeOptions = (property?: IProperty): IdName[] => {
  const commonLeaseTypes = [
    {
      id: LeaseTypeEnum.DIRECT,
      name: upperFirstLetter(LeaseTypeEnum.DIRECT),
    },
    {
      id: LeaseTypeEnum.SUBLEASE,
      name: upperFirstLetter(LeaseTypeEnum.SUBLEASE),
    },
    {
      id: LeaseTypeEnum.COWORKING,
      name: upperFirstLetter(LeaseTypeEnum.COWORKING),
    },
  ];

  const ukLeaseTypes = [
    {
      id: LeaseTypeEnum.LICENSE,
      name: upperFirstLetter(LeaseTypeEnum.LICENSE),
    },
    {
      id: LeaseTypeEnum.ASSIGNMENT,
      name: upperFirstLetter(LeaseTypeEnum.ASSIGNMENT),
    },
  ];

  const dataCenterLeaseTypes = [
    {
      id: LeaseTypeEnum.SHELL,
      name: upperFirstLetter(LeaseTypeEnum.SHELL),
    },
    {
      id: LeaseTypeEnum.TURN_KEY,
      name: formatEnumLabel(LeaseTypeEnum.TURN_KEY),
    },
  ];

  if (isUKCountry(property?.country)) {
    return [...commonLeaseTypes, ...ukLeaseTypes];
  }

  if (property && isDataCenterBuilding(property)) {
    return dataCenterLeaseTypes;
  }

  return commonLeaseTypes;
};

export const getLeaseTypeOptionsWithNumericId = (
  property?: IProperty,
): IdName[] => {
  const commonLeaseTypes = [
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.DIRECT],
      name: upperFirstLetter(LeaseTypeEnum.DIRECT),
    },
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.SUBLEASE],
      name: upperFirstLetter(LeaseTypeEnum.SUBLEASE),
    },
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.COWORKING],
      name: upperFirstLetter(LeaseTypeEnum.COWORKING),
    },
  ];

  const ukLeaseTypes = [
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.LICENSE],
      name: upperFirstLetter(LeaseTypeEnum.LICENSE),
    },
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.ASSIGNMENT],
      name: upperFirstLetter(LeaseTypeEnum.ASSIGNMENT),
    },
  ];

  const dataCenterLeaseTypes = [
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.SHELL],
      name: upperFirstLetter(LeaseTypeEnum.SHELL),
    },
    {
      id: LEASE_TYPE_ID_MAP[LeaseTypeEnum.TURN_KEY],
      name: formatEnumLabel(LeaseTypeEnum.TURN_KEY),
    },
  ];

  if (isUKCountry(property?.country)) {
    return [...commonLeaseTypes, ...ukLeaseTypes];
  }

  if (property && isDataCenterBuilding(property)) {
    return dataCenterLeaseTypes;
  }

  return commonLeaseTypes;
};

export const RECORD_TYPE_OPTIONS: IdName[] = [
  {
    id: LeaseRecordType.LEASE_COMPS,
    name: translateText('avantProperties.filters.lease.label.leaseComps'),
  },
  {
    id: LeaseRecordType.LEASE_EXPIRATIONS,
    name: translateText(
      'avantProperties.options.recordType.label.hasExpirationDate',
    ),
  },
  {
    id: LeaseRecordType.ALL_TENANTS,
    name: translateText('avantProperties.filters.lease.label.allTenants'),
  },
];
